import { VotersAndVotesForm } from "app/component/form/data_entry/voters_and_votes/VotersAndVotesForm";

export const VotersAndVotesPage = VotersAndVotesForm;
